import React, { Component } from 'react';
import PropTypes from 'prop-types';

import accountPropTypes from '../../../states/accounts/propTypes';
import managePayeeListContent, {
	contentPropTypes,
} from '../../../managePayee/components/managePayeeList/managePayeeList.content';
import withContent from '../../../containers/withContent';
import { payeePropTypes } from '../../../sharedComponents/FromToPayeeSelector/propTypes';
import PickerPagingView from '../PickerPagingView/PickerPagingView';
import AccountPicker from '../AccountPicker/AccountPicker';
import PayeePickerViewForManageYourPayee from './PayeePickerViewForManageYourPayee';

export class PayeePickerPagingView extends Component {
	render() {
		const {
			pageLoading,
			currentPage,
			totalNumberOfPages,
			onPageChanged,
			listViewSelected,
			accounts = [],
			onRetry,
			error,
			accountsNeverFetched,
			layoutType,
			payees = [],
			showPayees,
			handlePayeeSelect,
			getIsPayeeSelected,
			onFavouriteIconClick,
			isManageYourPayee,
			handleViewPayee,
			handleDeletePayee,
			handleEditPayee,
			handleEditChaps,
			handleImportPayees,
			isFileImportAllowed,
			handleTransferPayee,
			searchText,
			payeesNeverFetched,
			onSearchTextChanged,
			handleGoBack,
			onSearchTextSubmit,
			showAccountPicker,
			isBootStrapInProgress,
		} = this.props;
		if (isManageYourPayee) {
			return <PayeePickerViewForManageYourPayee {...this.props} />;
		}
		if (showAccountPicker) {
			return (
				<AccountPicker
					pageLoading={pageLoading}
					accounts={accounts}
					onPageChanged={onPageChanged}
					onSelectAccount={handlePayeeSelect}
					getIsAccountSelected={getIsPayeeSelected}
					onSearchTextChanged={onSearchTextChanged}
					handleGoBack={handleGoBack}
					layoutType={layoutType}
					onSearchTextSubmit={onSearchTextSubmit}
					handleFavouriteIconClick={onFavouriteIconClick}
					isBootStrapInProgress={isBootStrapInProgress}
					listViewSelected={listViewSelected}
				/>
			);
		}
		return (
			<PickerPagingView
				currentPage={currentPage}
				totalNumberOfPages={totalNumberOfPages}
				pageLoading={pageLoading}
				onPageChange={onPageChanged}
				payees={payees}
				listViewSelected={listViewSelected}
				onFavouriteIconClick={onFavouriteIconClick}
				error={error}
				onRetry={onRetry}
				searchText={searchText}
				accountsNeverFetched={accountsNeverFetched}
				layoutType={layoutType}
				showPayees={showPayees}
				accounts={accounts}
				handlePayeeSelect={handlePayeeSelect}
				getIsPayeeSelected={getIsPayeeSelected}
				isManageYourPayee={isManageYourPayee}
				handleViewPayee={handleViewPayee}
				handleDeletePayee={handleDeletePayee}
				handleEditPayee={handleEditPayee}
				handleEditChaps={handleEditChaps}
				handleImportPayees={handleImportPayees}
				isFileImportAllowed={isFileImportAllowed}
				handleTransferPayee={handleTransferPayee}
				payeesNeverFetched={payeesNeverFetched}
				isBootStrapInProgress={isBootStrapInProgress}
			/>
		);
	}
}

PayeePickerPagingView.propTypes = {
	pageLoading: PropTypes.bool.isRequired,
	currentPage: PropTypes.number.isRequired,
	totalNumberOfPages: PropTypes.number.isRequired,
	listViewSelected: PropTypes.bool.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	content: PropTypes.shape(contentPropTypes),
	onAccountClick: PropTypes.func,
	onFavouriteIconClick: PropTypes.func.isRequired,
	error: PropTypes.bool.isRequired,
	onRetry: PropTypes.func.isRequired,
	accountsNeverFetched: PropTypes.bool.isRequired,
	layoutType: PropTypes.string.isRequired,
	showPayees: PropTypes.bool.isRequired,
	payees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	handlePayeeSelect: PropTypes.func,
	getIsPayeeSelected: PropTypes.func,
	payeesNeverFetched: PropTypes.bool,
	showAccountPicker: PropTypes.bool,
	isBootStrapInProgress: PropTypes.bool,
	isManageYourPayee: PropTypes.bool,
	onPageChanged: PropTypes.func,
	handleViewPayee: PropTypes.func,
	handleDeletePayee: PropTypes.func,
	handleEditPayee: PropTypes.func,
	handleImportPayees: PropTypes.func,
	isFileImportAllowed: PropTypes.bool,
	handleTransferPayee: PropTypes.func,
	searchText: PropTypes.string,
	onSearchTextChanged: PropTypes.func,
	handleGoBack: PropTypes.func,
	onSearchTextSubmit: PropTypes.func,
};

export default withContent({ content: managePayeeListContent })(PayeePickerPagingView);
